import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'
import BuyTicketsButton from '../components/buyticketsbutton'

import Speaker from '../components/speaker'

const Section = styled.section`
  max-width: 1000px;
  h2 {
    margin-bottom: 5rem;
  }
  h2 + p,
  .buy-tickets {
    margin-bottom: 2.5rem;
    text-align: center;
  }
  div:last-of-type {
    border-bottom: 0;
    margin-bottom: 2.5rem;
  }
`

class SpeakersPage extends React.Component {
  render() {
    const { data } = this.props
    return (
      <Section>
        <h2>Speakers</h2>
        <p>
          <BuyTicketsButton
            href="https://www.lifeway.com/en/product/digital-pass-faith-leads-tech-conference-P005815391"
            target="_blank"
            onClick={() => {
              fbq('track', 'DigitalPass')
              twq('track', 'DigitalPass')
              gtag('event', 'buy-digital-pass-button', {
                event_category: 'button',
                event_label: 'Buy Digital Pass Speaker Page Top',
              })
            }}
          >
            Buy Conference Recordings - $35
          </BuyTicketsButton>
        </p>
        {data.allMarkdownRemark.edges.map(({ node }, i) => {
          const shortSlug = node.fields.slug.split('/')[2]
          return (
            <Speaker
              key={i}
              name={node.frontmatter.name}
              title={node.frontmatter.title}
              photo={node.frontmatter.profilePic.childImageSharp.sizes}
              photoTwo={
                node.frontmatter.profilePicTwo
                  ? node.frontmatter.profilePicTwo.childImageSharp.sizes
                  : null
              }
              bio={node.frontmatter.bio}
              twitter={node.frontmatter.twitter}
              website={node.frontmatter.website}
              talkTitle={node.frontmatter.talkTitle}
              talkHTML={node.html}
              shortSlug={shortSlug}
            />
          )
        })}
        <p className="buy-tickets">
          <BuyTicketsButton
            href="https://www.lifeway.com/en/product/digital-pass-faith-leads-tech-conference-P005815391"
            target="_blank"
            onClick={() => {
              fbq('track', 'DigitalPass')
              twq('track', 'DigitalPass')
              gtag('event', 'buy-digital-pass-button', {
                event_category: 'button',
                event_label: 'Buy Digital Pass Speaker Page Bottom',
              })
            }}
          >
            Buy Conference Recordings - $35
          </BuyTicketsButton>
        </p>
      </Section>
    )
  }
}

export default SpeakersPage

export const query = graphql`
  query SpeakersQuery {
    allMarkdownRemark {
      edges {
        node {
          fields {
            slug
          }
          excerpt
          html
          frontmatter {
            title
            name
            profilePic {
              childImageSharp {
                sizes {
                  base64
                  tracedSVG
                  aspectRatio
                  src
                  srcSet
                  srcWebp
                  srcSetWebp
                  sizes
                  originalImg
                  originalName
                }
              }
            }
            profilePicTwo {
              childImageSharp {
                sizes {
                  base64
                  tracedSVG
                  aspectRatio
                  src
                  srcSet
                  srcWebp
                  srcSetWebp
                  sizes
                  originalImg
                  originalName
                }
              }
            }
            twitter
            website
            bio
            talkTitle
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/speakers.js